import React from 'react';
import { connect, useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Tabs, Tab, Typography } from '@mui/material';
import { parseStringToInt } from '../../utils/parsing';
import { updateCurrentPath, getSearchParams } from '../../utils/url';
import { AUTH_LEVELS } from '../auth/Authorized';
import BuildingsLoader from '../loaders/BuildingsLoader';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import PointsView from './views/PointsView';
import EquipmentView from './views/EquipmentView';
import { Page, Row, Fill } from '../util/Page';
import ChangelogFilters from '../changelog/ChangelogFilters';
import useDatedBuildings from '../changelog/dated-buildings';
import { filterBuildings } from '../../redux/selectors/buildings';
import MeasurementsLoader from '../loaders/MeasurementsLoader';
import { CLEAR_FILTERS } from '../../redux/actions/actiontypes';
import ProcessingAlert from './elements/ProcessingAlert';

// First is the default
const VIEWS = { Point: PointsView, Equipment: EquipmentView };
const VIEW_KEYS = Object.keys(VIEWS);

const Staging = ({ orgId, buildingId, buildingsById, navigate, view = VIEWS[0] }) => {
  const [filters, setFilters] = useDatedBuildings({ orgId, buildingId });
  const buildings = filterBuildings(buildingsById, filters);
  const bid = buildings.length === 1 ? buildings[0] : null;
  const buildingName = buildingsById[bid]?.name;

  const dispatch = useDispatch();

  const setUrlAndFilters = (newFilters) => {
    const newBid = newFilters.buildings.length === 1 ? newFilters.buildings[0] : '';
    updateCurrentPath(navigate, { org: newFilters.orgId, bid: newBid });
    setFilters(newFilters);
    dispatch({ type: CLEAR_FILTERS });
  };

  return (
    <div>
      <Grid container>
        <ProcessingAlert buildingId={bid} />
        <BuildingsLoader />
        <OrganizationsLoader />
        <MeasurementsLoader />

        <Grid item xs={12}>
          <Page name="dashboard">
            <Row>
              <Typography variant="h6">Staging{buildingName && ` - ${buildingName}`}</Typography>
              <Fill />
              <ChangelogFilters
                filters={filters}
                setFilters={setUrlAndFilters}
                noDates
                singleBuilding
              />
            </Row>
            <Row>
              <Tabs
                indicatorColor="secondary"
                textColor="inherit"
                value={VIEW_KEYS.indexOf(view) < 0 ? 0 : VIEW_KEYS.indexOf(view)}
                onChange={(_event, val) => {
                  updateCurrentPath(navigate, { view: VIEW_KEYS[val] });
                  dispatch({ type: CLEAR_FILTERS });
                }}
              >
                {VIEW_KEYS.map((t) => (
                  <Tab key={t} label={t} />
                ))}
              </Tabs>
            </Row>
          </Page>
        </Grid>
        {React.createElement(VIEWS[view] ?? VIEWS[VIEW_KEYS[0]], { buildingId: bid })}
      </Grid>
    </div>
  );
};

export default connect(
  (
    {
      entities: {
        buildings: { byId },
      },
      user: { userAuthLevel },
    },
    { location: { search } }
  ) => {
    const { org, bid, view } = getSearchParams(search);
    return {
      orgId: parseStringToInt(org),
      buildingId: parseStringToInt(bid),
      buildingsById: byId,
      canCreateBuilding: userAuthLevel === AUTH_LEVELS.SUPER_ADMIN,
      view,
    };
  }
)(Staging);
